import { render } from "./ProductDetail.vue?vue&type=template&id=49acd415"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=49acd415&lang=less"
script.render = render

export default script